import { createContext as r, useContext as t } from "react";
const n = r(void 0);
function g() {
  const o = t(n);
  if (o === void 0)
    throw new Error("useComponentToggleContext must be used within a ComponentToggleProvider");
  return o;
}
function s(o) {
  const e = t(n);
  if (e === void 0)
    throw new Error("useComponentToggle must be used within a ComponentToggleProvider");
  return e.isEnabled(o);
}
export {
  n as ComponentToggleContext,
  s as useComponentToggle,
  g as useComponentToggleContext
};
